<template>
  <div>
    <small>
      <div
        class="content-color"
      >
        <i class="icon mr-1">
          <icon-info-circle />
        </i>
        <span
          v-dompurify-html="$t('noticeSortingCriterias:modalOpener')"
          class="cursor-pointer"
          @click="show"
          @keydown="show"
        />
      </div>
    </small>
  </div>
</template>
<script>
import IconInfoCircle from 'ICON:IconInfoCircle';
import { modalLogic } from 'mixins/composition/PickerModal';

export default {
  name: 'NoticeSortingCriterias',
  components: {
    IconInfoCircle,
  },
  i18nOptions: { namespaces: ['noticeSortingCriterias'] },
  setup() {
    const { togglePreventScroll } = modalLogic();
    return { togglePreventScroll };
  },
  methods: {
    async show() {
      const modal = await import(/* webpackChunkName: "notice-sorting-criterias-modal" */'components/NoticeSortingCriteriasModal.vue');
      this.$modal.show(modal.default, {
        method: this.method,
      }, {
        name: 'noticesortingcriterias-modal',
        class: 'noticesortingcriterias-modal',
        height: 'auto',
        adaptive: true,
        scrollable: true,
      }, {
        'before-open': () => { this.togglePreventScroll(true); },
        'before-close': () => { this.togglePreventScroll(false); },
      });
    },
  },
};
</script>
<style lang="scss" scoped>

.cursor-pointer {
   #app:not(.isTouchDevice) &:hover {
    cursor: pointer;
  }
}

/deep/ .client-underline{
  border-bottom: 1px solid $color_ci;
}
.content-color {
    color: $color_grey_700
}
</style>
